module.exports = __webpack_public_path__ + "static/media/Dwarf.e8ec4907.png";